"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeString = exports.encodeString = exports.stringReplace = void 0;
const stringReplace = (string, start, replacement, end = string.length) => {
    return (string.substring(0, start) +
        replacement +
        string.substring(end));
};
exports.stringReplace = stringReplace;
/** Encode string to base64 */
const encodeString = (str) => {
    const _unescape = window.unescape || window.decodeURI;
    return window.btoa(_unescape(encodeURIComponent(str)));
};
exports.encodeString = encodeString;
/** Decode base64 to string */
const decodeString = (encoded) => {
    const _escape = window.escape || window.encodeURI;
    return decodeURIComponent(_escape(window.atob(encoded)));
};
exports.decodeString = decodeString;
